import _objectWithoutProperties from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];
import { createElementObject, createLayerComponent, extendContext } from '@react-leaflet/core';
import { LayerGroup as LeafletLayerGroup } from 'leaflet';
export var LayerGroup = createLayerComponent(function createLayerGroup(_ref, ctx) {
  var _c = _ref.children,
    options = _objectWithoutProperties(_ref, _excluded);
  var group = new LeafletLayerGroup([], options);
  return createElementObject(group, extendContext(ctx, {
    layerContainer: group
  }));
});